/**
 * Persone su cui filtrare i dati della Dashboard (regole pure, testate in __tests__/personScope.test.ts).
 * Una persona sola viaggia come `filterUserId`; due o piu' persone scelte nella barra come `selectedUserIds`.
 * Risultato: [] = nessun filtro (tutto il team), [x] = una persona, [x, y, ...] = piu' persone.
 */
export function scopeIds(filterUserId: string | null | undefined, selectedUserIds: readonly string[] | null | undefined): string[] {
  if (filterUserId) return [filterUserId];
  return selectedUserIds && selectedUserIds.length >= 2 ? [...selectedUserIds] : [];
}

/** True se la persona rientra nel filtro (con filtro vuoto rientrano tutte, anche le righe senza assegnato). */
export function inScope(ids: readonly string[], userId: string | null | undefined): boolean {
  return ids.length === 0 || (!!userId && ids.includes(userId));
}

/** Applica il filtro persona a una query Supabase: .eq con una persona, .in con piu' persone. */
export function applyScope<Q>(query: Q, column: string, ids: readonly string[]): Q {
  // Tipi larghi di proposito: con i tipi dei query builder di Supabase la deduzione diventa "troppo profonda"
  const q = query as any;
  if (ids.length === 1) return q.eq(column, ids[0]);
  if (ids.length > 1) return q.in(column, [...ids]);
  return query;
}

/** Chiave stabile dell'elenco di persone (per le dipendenze degli effetti: cambia solo se cambia l'insieme). */
export function idsKey(ids: readonly string[]): string {
  return [...ids].sort().join(',');
}
